import produce from 'immer';
import { RequestState } from 'vrlcm-gui-types';
import { EnvironmentsAction } from '../actions/Environments';
import * as Constants from '../constants/action-constants';
import initialState from '../InitialState';
import { Environments } from '../types/Environments';

const environments = (
  state: Environments = initialState.environments,
  action: EnvironmentsAction
): Environments => {
  const nextState = produce<Environments, Environments>(state, draft => {
    switch (action.type) {
      case Constants.POLL_ENVIRONMENTS_START:
      case Constants.POLL_ENVIRONMENTS:
        draft.fetching = true;
        draft.failed = false;
        break;
      case Constants.POLL_ENVIRONMENTS_STOP:
        draft.fetching = false;
        draft.failed = false;
        break;
      case Constants.POLL_ENVIRONMENTS_SUCCESS:
        draft.fetching = false;
        draft.items = action.payload.environments;
        break;
      case Constants.POLL_ENVIRONMENTS_FAILED:
        draft.fetching = false;
        draft.failed = true;
        break;
      case Constants.CLEAR_ENVIRONMENTS:
        draft.items = {
          pending: [],
          completed: []
        }
        break;
      case Constants.DELETE_ENVIRONMENT: {
        const {
          environmentId,
          state: environmentState,
          deleteFromInventory
        } = action.payload;
        const index = draft.items[environmentState].findIndex(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (index >= 0) {
          const environment = draft.items[environmentState][index];
          draft.items[environmentState].splice(index, 1);
          if (
            environment.requestState !== RequestState.DELETED &&
            environment.requestState !== RequestState.UI_INPROGRESS &&
            !deleteFromInventory
          ) {
            environment.requestState = RequestState.DELETED;
            draft.items.pending.push(environment);
          }
        }
        break;
      }
      case Constants.DELETE_PRODUCT: {
        const { environmentId, productId } = action.payload;
        const environment = draft.items.completed.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          const index = environment.environmentRequestDTO.products.findIndex(
            p => p.id === productId
          );
          if (index >= 0) {
            environment.environmentRequestDTO.products.splice(index, 1);
          }
        }
        break;
      }
      case Constants.EXPORT_CONFIGURATION: {
        const { environmentId } = action.payload;
        const environment = draft.items.completed.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          environment.uiOperationInprogress = true;
        }
        break;
      }
      case Constants.EXPORT_CONFIGURATION_SUCCESS: {
        const { environmentId } = action.payload;
        const environment = draft.items.completed.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          environment.uiOperationInprogress = false;
        }
        break;
      }
      case Constants.EXPORT_PRODUCT_CONFIGURATION: {
        const { environmentId, productId } = action.payload;
        const environment = draft.items.completed.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          environment.uiOperationInprogress = true;
          const product = environment.environmentRequestDTO.products.find(
            p => p.id === productId
          );
          if (product) {
            product.uiOperationInprogress = true;
          }
        }
        break;
      }
      case Constants.EXPORT_PRODUCT_CONFIGURATION_SUCCESS: {
        const { environmentId, productId } = action.payload;
        const environment = draft.items.completed.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          environment.uiOperationInprogress = false;
          const product = environment.environmentRequestDTO.products.find(
            p => p.id === productId
          );
          if (product) {
            product.uiOperationInprogress = false;
          }
        }
        break;
      }

      case Constants.RENAME_ENVIRONMENT: {
        const { environmentId, environmentName, environmentDescription } = action.payload;
        const allEnvironments = [
          ...draft.items.completed,
          ...draft.items.pending
        ];
        const environment = allEnvironments.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          environment.environmentRequestDTO.environmentName = environmentName;
          environment.environmentDescription = environmentDescription;
        }
        break;
      }

      case Constants.UPDATE_ENVIRONMENT: {
        const { environmentId } = action.payload;
        const allEnvironments = [
          ...draft.items.completed,
          ...draft.items.pending
        ];
        const environment = allEnvironments.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          environment.uiOperationInprogress = true;
        }
        break;
      }

      case Constants.UPDATE_ENVIRONMENT_SUCCESS: {
        const { environment } = action.payload;
        const allEnvironments = [
          ...draft.items.completed,
          ...draft.items.pending
        ];
        const existingEnvironment = allEnvironments.find(
          e =>
            e.environmentRequestDTO.environmentId === environment.environmentId
        );
        if (existingEnvironment) {
          existingEnvironment.uiOperationInprogress = false;
          existingEnvironment.environmentRequestDTO = environment;
        }
        break;
      }

      case Constants.UPDATE_CLUSTER_HEALTH_CHECK_STATUS: {
        const { environmentId, productId, status } = action.payload;
        const environment = draft.items.completed.find(
          e => e.environmentRequestDTO.environmentId === environmentId
        );
        if (environment) {
          const product = environment.environmentRequestDTO.products.find(
            p => p.id === productId
          );
          if (product) {
            product.vIdmClusterHealthCheckStatus = status;
          }
        }
      }
      // no default
    }
  });
  return nextState;
};

export default environments;
